import { HTTPClientInterface, HTTPRequest } from '@shared/core/HTTPClientInterface';
import { buildURL, SystemURL } from "./URLCatalog";

export type HourBankCompensationRequestStatus =
    | "PENDING"
    | "APPROVED"
    | "REJECTED"
    | "CANCELLED";

export interface HourBankCompensationApprovalData {
    approvedBy?: string;
    approvedAt?: number;
    rejectedBy?: string;
    rejectedAt?: number;
    reason?: string;
}

export interface HourBankCompensationRequest {
    id: string;
    organizationID: string;
    userID: string;
    requesterWhatsappID: string;
    ticketID?: string;
    waFlowToken: string;
    status: HourBankCompensationRequestStatus;
    day: string;
    requestedMinutes: number;
    balanceMinutesAtRequest: number;
    createdAt: number;
    updatedAt: number;
    approvalData?: HourBankCompensationApprovalData;
}

export class HourBankCompensationService {
    private httpClient: HTTPClientInterface;

    constructor(httpClient: HTTPClientInterface) {
        this.httpClient = httpClient;
    }

    async getPendingRequests(organizationID: string): Promise<HourBankCompensationRequest[]> {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.HourBankCompensation.getPendingRequests, {
            org_id: organizationID,
        });
        request.method = "GET";

        const response = await this.httpClient.execute(request);
        return (response.result ?? []) as HourBankCompensationRequest[];
    }

    async getProcessedRequests(organizationID: string): Promise<HourBankCompensationRequest[]> {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.HourBankCompensation.getProcessedRequests, {
            org_id: organizationID,
        });
        request.method = "GET";

        const response = await this.httpClient.execute(request);
        return (response.result ?? []) as HourBankCompensationRequest[];
    }

    async approveRequest(flowToken: string, description: string): Promise<unknown> {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.HourBankCompensation.postApproveRequest, {
            flow_token: flowToken,
        });
        request.method = "POST";
        request.body = {
            description: description ?? "",
        };

        return this.httpClient.execute(request);
    }

    async rejectRequest(flowToken: string, description: string): Promise<unknown> {
        const request = new HTTPRequest();
        request.url = buildURL(SystemURL.HourBankCompensation.postRejectRequest, {
            flow_token: flowToken,
        });
        request.method = "POST";
        request.body = {
            description: description ?? "",
        };

        return this.httpClient.execute(request);
    }
}

export default HourBankCompensationService;
